import React, { useState } from "react";
import CadastroContainer from "../../components/CadastroContainer/CadastroContainer";
import DraggableList from "../../components/DraggableList/DraggableList";
import PageTitle from "../../components/PageTitle/PageTitle";
import { useUserStore } from "../../contexts/userStore";
import "./Monitoring.css";
import OpenDoorCard from "../../components/OpenDoorCard/OpenDoorCard";
import AutomationCard from "../../components/AutomationCard/AutomationCard";
import AlarmCard from "../../components/AlarmCard/AlarmCard";
import Spacer from "../../components/Spacer/Spacer";
import Tabbar from "../../components/Tabbar/Tabbar";
import Tabbutton from "../../components/Tabbutton/Tabbutton";
import AggregatesService from "../../services/AggregatesService";
import Checkbox from "../../components/Checkbox/Checkbox";
import { BiCheckShield } from "react-icons/bi";

const Monitoring = () => {
	const [alarmItems, setAlarmItems] = useState([]);
	const [accessPointsItems, setAccessPointsItems] = useState([]);
	const [automationButtonsItems, setAutomationButtonsItems] = useState([]);
	const [tabContent, setTabContent] = useState(1);
	const {
		selectedCondominio,
		selectedCondominioObj,
		handleMonitoringShowCondoCommands,
		monitoringShowCondoCommands,
	} = useUserStore();

	const getCards = async (condominiumId) => {
		const response = await AggregatesService.listMonitoringCards(condominiumId);
		const alarms = response.data?.events;
		const accessPoints = response.data?.accessPoints;
		const automationButtons = response.data?.automation;

		const alarmItemsArray = alarms.map((alarm, alarmId) => ({
			id: alarmId.toString(),
			content: <AlarmCard alarm={alarm} />,
		}));

		const accessPointsItemsArray = accessPoints.map((access, accessId) => ({
			id: accessId.toString(),
			content: <OpenDoorCard access={access} />,
		}));

		const automationButtonsItemsArray = automationButtons.map(
			(automation, automationId) => ({
				id: automationId.toString(),
				content: <AutomationCard automation={automation} />,
			}),
		);

		if (alarmItemsArray.length === 0) {
			setAlarmItems([
				{
					id: "1",
					content: (
						<div style={{ color: "gray" }}> Nenhum alarme encontrado </div>
					),
				},
			]);
		} else setAlarmItems(alarmItemsArray);

		if (accessPointsItemsArray.length === 0) {
			setAccessPointsItems([
				{
					id: "1",
					content: (
						<div style={{ color: "gray" }}>
							{" "}
							Nenhum ponto de acesso cadastrado no condomínio{" "}
						</div>
					),
				},
			]);
		} else setAccessPointsItems(accessPointsItemsArray);

		if (automationButtonsItemsArray.length === 0) {
			setAutomationButtonsItems([
				{
					id: "1",
					content: (
						<div style={{ color: "gray" }}>
							{" "}
							Nenhuma automação disponível no condomínio
						</div>
					),
				},
			]);
		} else setAutomationButtonsItems(automationButtonsItemsArray);
	};

	React.useEffect(() => {
		if (selectedCondominio === 0) return;
		getCards(selectedCondominio);
	}, [selectedCondominio]);

	const handleTabChange = (tabId) => {
		setTabContent(tabId);
		handleMonitoringShowCondoCommands(false);
	};

	const handleCheckboxChange = (checked) => {
		handleMonitoringShowCondoCommands(checked);
		setTabContent(1);
	};

	return (
		<CadastroContainer>
			<PageTitle
				title="Monitoramento"
				icon={<BiCheckShield size={23} />}
			></PageTitle>
			<div className={"monitoring-checkbox"}>
				<Checkbox
					labelText="Exibir Comandos do Condomínio"
					defaultChecked={monitoringShowCondoCommands}
					onChange={({ target }) => handleCheckboxChange(target.checked)}
					required={false}
					minWidthLabel="150px"
				/>
			</div>
			<div className="monitoring-tab-bar">
				<Tabbar>
					<Tabbutton
						tabButtonLabel="Alarmes"
						tabId={1}
						handleClick={(tabId) => handleTabChange(tabId)}
						tabSelected={tabContent}
					/>
					<Tabbutton
						tabButtonLabel="Portaria"
						tabId={2}
						handleClick={(tabId) => handleTabChange(tabId)}
						tabSelected={tabContent}
					/>
					<Tabbutton
						tabButtonLabel="Automação"
						tabId={3}
						handleClick={(tabId) => handleTabChange(tabId)}
						tabSelected={tabContent}
					/>
				</Tabbar>
			</div>
			<div
				style={{ display: "flex", marginTop: "37px", justifyContent: "center" }}
			>
				{tabContent === 1 && (
					<div className="monitoring-alarm-container">
						{alarmItems?.map((item, itemId) => (
							<div key={itemId}>{item.content}</div>
						))}
					</div>
				)}
				{(monitoringShowCondoCommands || tabContent === 2) && (
					<React.Fragment>
						<Spacer marginLeft={"20"} />
						<DraggableList
							initialGroups={[
								{
									name: "Portaria - " + selectedCondominioObj?.name,
									items: accessPointsItems,
								},
							]}
						/>
					</React.Fragment>
				)}
				{(monitoringShowCondoCommands || tabContent === 3) && (
					<React.Fragment>
						<Spacer marginLeft={"20"} />
						<DraggableList
							initialGroups={[
								{
									name: "Automação - " + selectedCondominioObj?.name,
									items: automationButtonsItems,
								},
							]}
						/>
					</React.Fragment>
				)}
			</div>
		</CadastroContainer>
	);
};

export default Monitoring;
